/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ArrowCurveUpLeft({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M6.424 2.576a.6.6 0 0 1 0 .848L4.45 5.4H10A3.6 3.6 0 0 1 13.6 9v4a.6.6 0 1 1-1.2 0V9A2.4 2.4 0 0 0 10 6.6H4.449l1.975 1.976a.6.6 0 0 1-.848.848l-3-3a.6.6 0 0 1 0-.848l3-3a.6.6 0 0 1 .848 0Z" clipRule="evenodd" /></svg>;
}
;